import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePage } from '@inertiajs/react';
import Layout from '@/layouts/Layout';

interface PageProps {
  [key: string]: unknown;
  csrf_token: string;
}

export function Login() {
  const { props } = usePage<PageProps>();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Sign In</CardTitle>
          <CardDescription>Sign in using your company's Google account.</CardDescription>
        </CardHeader>
        <CardContent>
          <form action="/users/auth/google_oauth2" method="POST">
            <input type="hidden" name="authenticity_token" value={props.csrf_token} />
            <Button type="submit" className="w-full">
              Sign in with Google
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

Login.layout = (page: React.ReactNode) => <Layout children={page} />;

export default Login;
